<template>
  <router-view />
</template>

<script lang="ts">
import { validateOrgNr } from "@/lib/validators";
import { defineComponent, reactive, ref } from "vue";
import { useOrganisationStore } from "@/stores/organisation";
import CtaPanel from "../components/CtaPanel.vue";

export default defineComponent({

  name: "RegistrationForm",
  components: {
    CtaPanel
  },
  setup() {
    const state = reactive({
      orgNumber: null,
      orgNumberExist: true,
      orgNumberValid: false
    });

    const OrganisationStore = useOrganisationStore();

    // demo data
    const demoData = {
      name: "Consid AB",
      address: "Östra storgatan ",
      zipcode: "61136",
      city: "Nyköping",
      phone: "+46(0)123456789"
    };

    const form = ref({
      orgNo: ""
    });

    const onSubmit = () => {
      if (validateOrgNr(form.value.orgNo)) {
        const result = OrganisationStore.SearchByOrgNr(form.value.orgNo);
      }
    };

    return {
      state,
      demoData,
      form,
      onSubmit
    };
  }
});
</script>

<style lang="scss" scoped>
.reg-form {
  &__wrapper {

    background: var(--spsm-gray-5);
    padding: 1rem;
    border-radius: 0.2rem;
  }

  .org-information-list {
    display: grid;
    grid-template-columns: 6rem auto;

    &:first-child {
      font-weight: bold;
    }

    &__item {

    }
  }

}
</style>